import { createJSONStorage } from 'jotai/utils';

import { atomWithStorage } from '~shared/lib/atom-state';

export type MobileAuthTheme = 'light' | 'dark' | 'system';

export type ResolvedMobileAuthTheme = 'light' | 'dark';

export const isMobileAuthAtom = atomWithStorage<boolean>('mobileAuth', false);

const themeStorage = {
  ...createJSONStorage<MobileAuthTheme>(() => localStorage),
  getItem: (key: string): MobileAuthTheme => {
    if (typeof localStorage === 'undefined') {
      return 'light';
    }

    const raw = localStorage.getItem(key);

    if (raw === null) {
      return 'light';
    }

    const stripped = raw.replace(/^['"]|['"]$/g, '');

    if (stripped === 'dark' || stripped === 'light' || stripped === 'system') {
      return stripped;
    }

    return 'light';
  },
};

export const mobileAuthThemeAtom = atomWithStorage<MobileAuthTheme>(
  'mobileAuthTheme',
  'light',
  themeStorage
);

const isBrowser = typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export const getSystemTheme = (): ResolvedMobileAuthTheme => {
  if (!isBrowser) {
    return 'light';
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const resolveMobileAuthTheme = (theme: MobileAuthTheme): ResolvedMobileAuthTheme => {
  if (theme === 'system') {
    return getSystemTheme();
  }

  return theme;
};
